import React from "react";
import "./Reasons.scss";
import bgImg from "../../assets/.png"; 

const ITEMS = [
  {
    title: "Tailored to Your Workflow",
    text:
      "We design software and hardware around how your teams actually work—so rollouts are smooth, adoption is fast, and change never feels like chaos.",
  },
  {
    title: "Certified, Hands-On Team",
    text:
      "Engineers with real deployments across web & mobile apps, cloud, networks, CCTV, access control, and server rooms—documented, tested, and monitored.",
  },
  {
    title: "Security by Design",
    text:
      "Zero-trust principles, hardened configs, encryption, access auditing, and backups are built in from day one—not bolted on later.",
  },
  {
    title: "End-to-End Delivery",
    text:
      "From discovery and architecture to procurement, installation, CI/CD, and user training—we own the outcome, not just the tickets.",
  },
  {
    title: "Proactive Support & AMC",
    text:
      "SLA-backed support with preventative maintenance, asset tracking, and scheduled health checks to keep everything running reliably.",
  },
  {
    title: "Transparent Costs & Docs",
    text:
      "Clear estimates, no hidden fees, and living documentation—network diagrams, runbooks, and SOPs your team can trust.",
  },
];

export default function Reasons() {
  return (
    <section
      className="avena-reasons"
      style={{
        // Set/replace this with your actual image URL or imported asset:
        "--reasons-bg-image": `url(${bgImg})`,
        // "--reasons-bg-image": "url(/assets.jpg)",
      }}
    >
      <div className="container">
        <div className="row align-items-center mb-4 mb-lg-5">
          <div className="col-12 col-lg-8">
            <h2 className="avena-reasons__title">
              Why Businesses Trust
              <span> Avena ?</span>
            </h2>
          </div>

          {/* <div className="col-12 col-lg-4 d-flex justify-content-lg-end mt-3 mt-lg-0">
            <a href="#contact" className="btn avena-reasons__cta">
              Explore More
            </a>
          </div> */}
        </div>

        <div className="row g-4 g-xl-5 avena-reasons__grid">
          {ITEMS.map((it, idx) => (
            <div className="col-12 col-lg-4" key={idx}>
              <article className="avena-reasons__card">
                <div className="avena-reasons__titleRow">
                  <span className="avena-reasons__check" aria-hidden="true">✓</span>
                  <h3 className="avena-reasons__cardTitle">{it.title}</h3>
                </div>

                <div className="avena-reasons__divider" />
                <p className="avena-reasons__text">{it.text}</p>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
